/**
 * @prettier
 */
import {createSelector} from 'reselect';
import {getTripData} from './store';
import {getLocation} from './searchBox';
import {toURL} from '@homeaway/search-url-parser';

const getSearchUrl = createSelector(
    [getTripData, getLocation],
    (tripData, location) => {
        return toURL({
            arrival: tripData.arriveDateText,
            departure: tripData.departDateText,
            q: encodeURIComponent(location),
            adultsCount: tripData.adults,
            childrenCount: tripData.children,
            petIncluded: tripData.hasPets
        });
    }
);

const getSearchBaseUrl = createSelector(
    [getTripData],
    (tripData) => {
        return toURL({
            arrival: tripData.arriveDateText,
            departure: tripData.departDateText,
            adultsCount: tripData.adults,
            childrenCount: tripData.children,
            petIncluded: tripData.hasPets
        });
    }
);

export default getSearchUrl;

export {getSearchUrl, getSearchBaseUrl};
